import { render, staticRenderFns } from "./age.vue?vue&type=template&id=c420be56&scoped=true"
import script from "./age.vue?vue&type=script&lang=ts"
export * from "./age.vue?vue&type=script&lang=ts"
import style0 from "./age.vue?vue&type=style&index=0&id=c420be56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c420be56",
  null
  
)

export default component.exports